import * as z from 'zod';

// Define the schema for the claimed lead
const claimedLeadSchema = z
  .object({
    name: z.string(),
    phoneNumber: z.string(),
    id: z.string().optional(),
    email: z.string().optional(),
    bio: z.string().optional(),
    photo_url: z.string().optional(),
  })
  .optional()
  .nullable(); // Allow null values as well

export const contactSchema = z.object({
  firstName: z
    .string()
    .min(1, 'First name is required')
    .transform((val) => val.trim()),
  lastName: z.string().transform((val) => val.trim()),
  phoneNumber: z
    .string()
    .transform((val) => {
      // If empty string or only contains non-digit characters, return empty string
      if (!val || val.replace(/\D/g, '') === '') {
        return '';
      }
      // Otherwise, remove all non-digit characters
      return val.replace(/\D/g, '');
    })
    .pipe(
      z.string().refine(
        (val) => {
          // Empty string is allowed
          if (val === '') {
            return true;
          }
          // Otherwise, validate as a phone number
          return /^[1-9]\d{9,14}$/.test(val);
        },
        {
          message: 'Please enter a valid phone number',
        }
      )
    ),
  phoneStatus: z.string().transform((val) => val.trim()),
  email: z
    .string()
    .email('Invalid email format')
    .transform((val) => val.trim())
    .optional()
    .or(z.literal('')),
  address: z.object({
    street: z.string().transform((val) => val.trim()),
    city: z.string().transform((val) => val.trim()),
    state: z.string().transform((val) => val.trim()),
    zip: z.string().transform((val) => val.trim()),
  }),
  opt_in: z.boolean(),
  opt_in_date: z.string().optional(),
  opt_in_desc: z.string().optional(),
  leadSource: z.string().optional(),
  call_tester: z.boolean(),
  tags: z.array(z.string()).optional(),
  claimedLead: claimedLeadSchema,
  claimedLeadSource: z.string().nullable().optional(),
  assignedAgentId: z.string().nullable().optional(),
  assignedPondId: z.string().nullable().optional(),
  assignedAgent: z
    .object({
      agentId: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string().nullable().optional(),
      phone: z.string().nullable().optional(),
      photoUrl: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
  firebaseUid: z.string().optional(),
});

export type ContactFormData = z.infer<typeof contactSchema>;
